import { createRouter, createWebHistory } from 'vue-router';

// import NProgress from 'nprogress';
// import moment from 'moment-timezone';
// import { G } from "@/_common";

import { main_routes } from "./routes";
import { user_routes } from "@/_routes";

// export const routesObj = {};
// main_routes.forEach(e => {
//     routesObj[e.name] = e;
// });
// user_routes.forEach(e => {
//     routesObj[e.name] = e;
// });

// export const routes = [
//     ...main_routes,
//     ...user_routes,
// ];

export const routes = Array.from(
    [...main_routes, ...user_routes]
    .reduce((m, o) => m.set(o.name, o), new Map)
    .values()
);


const router = createRouter({
    // history: createWebHistory(process.env.BASE_URL),
    // history: createWebHashHistory(),
    history: createWebHistory(),
    base: '',
    // base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 }
    }
});

// router.beforeResolve((to, from, next) => {
//     if (to.name) {
//         NProgress.start();
//         next();
//     } else {
//         next();
//     }
// });

router.beforeEach((to, from, next) => {
    // NProgress.start();
    if (from.fullPath.length > 2 && from.fullPath.slice(0, 3) != to.fullPath.slice(0, 3)) {
        let translatedPath = from.fullPath.replace(from.fullPath.slice(0, 3), to.fullPath.slice(0, 3));
        from.fullPath = translatedPath;
        from.path = translatedPath;
        from.href = translatedPath;
        next({ path: translatedPath, query: to.query, hash: to.hash, params: {lang: to.params.lang !== undefined ? to.params.lang : 'az'} });
    }
    else if (to.path == '/') {
        next({
            path: '/az',
            // force: true,
            // query: { redirect: to.fullPath },
            params: {lang: to.params.lang !== undefined ? to.params.lang : 'az'}
        });
    }
    else
        next();
});

router.afterEach(() => {
    // NProgress.done();
});


export default router;
